export function hack__toString(number) {
    var _a;
    return (_a = number === null || number === void 0 ? void 0 : number.toString()) !== null && _a !== void 0 ? _a : null;
}
